import './QuizQuestion.css';

function FindInTextQuestion({ question, selectedWords, onWordSelect }) {
    // Split text into words while preserving punctuation
    const tokenizeText = (text) => {
        // Split by spaces and keep track of punctuation
        const words = text.split(/\s+/);
        return words.map((word, index) => ({
            id: index,
            original: word,
            word: word
        }));
    };

    const tokens = tokenizeText(question.text);
    const selected = selectedWords || [];

    const handleWordClick = (token) => {
        if (selected.includes(token.id)) {
            // Deselect
            onWordSelect(selected.filter(id => id !== token.id));
        } else {
            // Add to selection
            onWordSelect([...selected, token.id]);
        }
    };

    return (
        <div className="findintext-question">
            <h2 className="question-text">{question.questionText}</h2>

            <div className="findintext-instruction">
                Klikněte na hledané slovo nebo slova v textu.
            </div>

            <div className="findintext-container">
                <div className="findintext-text">
                    {tokens.map((token, index) => (
                        <span key={token.id}>
                            <span
                                className={`findintext-word ${selected.includes(token.id) ? 'selected' : ''}`}
                                onClick={() => handleWordClick(token)}
                            >
                                {token.word}
                            </span>
                            {index < tokens.length - 1 && ' '}
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default FindInTextQuestion;
